import { createSvgIcon } from "@mui/material/utils";

/**
 * Admin icon.
 *
 * ![AdminIcon](data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSItMi44OCAtMi44OCAyOS43NiAyOS43NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHN0eWxlPSJiYWNrZ3JvdW5kOiNmZmY7Ym9yZGVyLXJhZGl1czo0cHgiPjxwYXRoIGQ9Ik0xMiAxNUg4QzYuMTM2MjMgMTUgNS4yMDQzNSAxNSA0LjQ2OTI3IDE1LjMwNDVDMy40ODkxNSAxNS43MTA1IDIuNzEwNDYgMTYuNDg5MiAyLjMwNDQ4IDE3LjQ2OTNDMiAxOC4yMDQ0IDIgMTkuMTM2MiAyIDIxTTE1LjUgMy4yOTA3NkMxNi45NjU5IDMuODg0MTUgMTggNS4zMjEzMSAxOCA3QzE4IDguNjc4NjkgMTYuOTY1OSAxMC4xMTU5IDE1LjUgMTAuNzA5Mk0xMy41IDdDMTMuNSA5LjIwOTE0IDExLjcwOTEgMTEgOS41IDExQzcuMjkwODYgMTEgNS41IDkuMjA5MTQgNS41IDdDNS41IDQuNzkwODYgNy4yOTA4NiAzIDkuNSAzQzExLjcwOTEgMyAxMy41IDQuNzkwODYgMTMuNSA3Wk0xOSAyMUMxOSAyMSAyMiAxOS41NzAxIDIyIDE3LjQyNTJWMTQuOTIyOUwxOS44MTI0IDE0LjE0MTJDMTkuMjg2OCAxMy45NTI5IDE4LjcxMiAxMy45NTI5IDE4LjE4NjQgMTQuMTQxMkwxNiAxNC45MjI5VjE3LjQyNTJDMTYgMTkuNTcwMSAxOSAyMSAxOSAyMVoiIHN0cm9rZT0iIzEwMTgyOCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjwvcGF0aD48L3N2Zz4=)
 */
const AdminIcon = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    >
    <path
      d="M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7ZM19 21C19 21 22 19.5701 22 17.4252V14.9229L19.8124 14.1412C19.2868 13.9529 18.712 13.9529 18.1864 14.1412L16 14.9229V17.4252C16 19.5701 19 21 19 21Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  "Admin"
);

export default AdminIcon;
